import { mapDTO } from '@twistezo/ts-dto-mapper'

import { JSON_SPACE } from 'constants/json'
import { RichPlacementMultiAnchor } from '../types'
import { RichPlacementMultiAnchorDTO } from './types'

type From = RichPlacementMultiAnchorDTO
type To = RichPlacementMultiAnchor

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      customStyling,
      displayAfterUserInteractionEnabled,
      fullWidthModeEnabled,
      showCloseButtonEnabled,
      singleAdViewTime,
    }: From): To => ({
      customStyling: JSON.stringify(customStyling, null, JSON_SPACE),
      displayAfterUserInteraction: displayAfterUserInteractionEnabled,
      fullWidthMode: fullWidthModeEnabled,
      showCloseButton: showCloseButtonEnabled,
      singleAdViewTime,
    }),
  )
